import React from 'react';

import {
  CALENDAR,
  ROLE_ASSIGNMENTS,
  STEPPER,
  TABLE,
  WIDGET_TEXT,
  ACTIVITY_LOG
} from 'src/views/constants/perspectiveConstants';
import { Box, Grid } from '@material-ui/core/index';
import WidgetCard from '../common/WidgetCard';

const Toolbox = ({
  perspectiveId,
  setIsDragging
}: any) => {
  const widgets = [
    {
      label: 'Text',
      description: 'A box full of rich text.',
      icon: 'type',
      widgetType: WIDGET_TEXT,
    },
    {
      label: 'Table',
      description: 'For tabular data with search, ordering, and pagination.',
      icon: 'grid',
      widgetType: TABLE,
    },
    {
      label: 'Calendar',
      description: 'For date-based data in a monthly, weekly, or daily view.',
      icon: 'calendar',
      widgetType: CALENDAR,
    },
    {
      label: 'Progress map',
      description: 'Show the steps of the workflow.',
      icon: 'share-2',
      widgetType: STEPPER,
    },
    {
      label: 'Activity log',
      description: 'A list of events for the engagement or workflow.',
      icon: 'activity',
      widgetType: ACTIVITY_LOG,
    },
    {
      label: 'Role assignments',
      description: 'Show what users are currently assigned to roles.',
      icon: 'users',
      widgetType: ROLE_ASSIGNMENTS,
    },
  ];

  return (
    <Box mt={2}>
      <Grid container spacing={1}>
        {widgets.map((widget) => (
          <Grid item xs={12}>
            <WidgetCard
              {...widget}
              perspectiveId={perspectiveId}
              setIsDragging={setIsDragging}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Toolbox;
